import React from "react";
import UserProfileLink from "components/shared/user-profile-link";
import PropTypes from "prop-types";

const CoachesTableRow = ({ data, openModal = () => {}, isTotalsRow = false }) => {

  const totalsRowStyle = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr",
    width: "100%",
    fontSize: "14px",
  };

  return (
    <tr style={isTotalsRow ? totalsRowStyle : undefined}>
      <td>
        {isTotalsRow
          ? <span style={{ lineHeight: "inherit" }}>Totals</span>
          : <UserProfileLink userId={data?.CoachId}>{data?.CoachName}</UserProfileLink>
        }
      </td>
      
      <td style={{ cursor: "pointer" }}
        onClick={() => {
          openModal({ type: "Total", coachId: data.CoachId, origin });
        }}>
        {data?.TotalPatientsCount}
      </td>
      <td style={{ cursor: "pointer" }}
        onClick={() => {
          openModal({ type: "Scheduled", coachId: data.CoachId, origin });
        }}>
        {data?.TotalScheduledPatientsCount}
      </td>
      <td style={{ cursor: "pointer" }}
        onClick={() => {
          openModal({ type: "Not-Scheduled", coachId: data.CoachId, origin });
        }}>
        {data?.TotalNotScheduledPatientsCount}
      </td>
      <td style={{ cursor: "pointer" }}
        onClick={() => {
          openModal({ type: "In-Progress", coachId: data.CoachId, origin });
        }}>
        {data?.TotalInProgressPatientsCount}
      </td>
      <td style={{ cursor: "pointer" }}
        onClick={() => {
          openModal({ type: "Compliance", coachId: data.CoachId, origin });
        }}>
        {data?.TotalCompliancePatientsCount}
      </td>
      <td>
        {Math.round(data?.AverageContactsCount).toFixed(2)}
      </td>
      <td>
        {Math.round(data?.AverageDays ?? 0).toFixed(2)}
      </td>
    </tr>
  );
};

CoachesTableRow.propTypes = {
  data: PropTypes.object.isRequired,
  openModal: PropTypes.func.isRequired,
  isTotalsRow: PropTypes.bool
};

export default CoachesTableRow;
